import {NoteChangePriceRow} from "../types/note-change-price.types";

export const noteChangePriceRows: Array<NoteChangePriceRow> = [
  {
    key: 'customerPrice',
    label: 'Цена для клиента'
  },
  {
    key: 'spp',
    label: 'СПП'
  },
  {
    key: 'marketplacePrice',
    label: 'Цена на МП'
  },
  {
    key: 'unitProfit',
    label: 'Прибыль на ед.'
  },
  {
    key: 'cpo',
    label: 'CPO'
  },
  {
    key: 'advertisementsExpensesShare',
    label: 'ДРР'
  },
  {
    key: 'salesQuantity',
    label: 'Количество продаж'
  },
  {
    key: 'revenue',
    label: 'Выручка'
  },
  {
    key: 'profit',
    label: 'Прибыль'
  },
  {
    key: 'advertisementBudget',
    label: 'Рекламный бюджет'
  },
  {
    key: 'comment',
    label: ''
  }
]
